import type { FabPosition, FabSide, WidgetRuntimeConfig } from '../types/public';

/**
 * Парсит "left"/"right" из произвольного значения (query-string или config).
 * Возвращает undefined для невалидного — caller использует fallback.
 */
export function parseFabSide(raw: unknown): FabSide | undefined {
  if (raw === 'left' || raw === 'right') return raw;
  return undefined;
}

/**
 * Парсит число от 0 до 1000 (px) для `bottom` offset'а.
 * Принимает как number, так и строку (для query-string совместимости).
 * Cap 1000px защищает от случайных огромных значений из БД.
 */
export function parseFabBottom(raw: unknown): number | undefined {
  if (raw === null || raw === undefined) return undefined;
  const n = typeof raw === 'number' ? raw : Number(raw);
  if (!Number.isFinite(n) || n < 0 || n > 1000) return undefined;
  return n;
}

/**
 * Финальная FAB-позиция с учётом приоритета: runtime config (из БД) >
 * boot config (из script-tag query-string) > defaults.
 *
 * Виджет не показывается до получения runtime config (см. main.tsx fetchWidgetConfig),
 * так что визуального jump'а нет — позиция всегда финальная при первом рендере.
 */
export function resolveFabPosition(
  bootFab: FabPosition,
  runtimeConfig: WidgetRuntimeConfig | null | undefined,
  device: 'desktop' | 'mobile',
): FabPosition {
  if (!runtimeConfig) return bootFab;
  const sideKey = device === 'mobile' ? 'fab_mobile_side' : 'fab_desktop_side';
  const bottomKey = device === 'mobile' ? 'fab_mobile_bottom' : 'fab_desktop_bottom';
  return {
    side: parseFabSide(runtimeConfig[sideKey]) ?? bootFab.side,
    bottom: parseFabBottom(runtimeConfig[bottomKey]) ?? bootFab.bottom,
  };
}
